import React, { useCallback } from "react";
import { MenuOptionGroup } from "@chakra-ui/react";
export function FilterMenuGroup({ type, onChange, ...props }) {
    const valueChanged = useCallback((value) => {
        if (type === "radio" && typeof value === "string") {
            onChange(value);
        }
        if (type === "checkbox" && Array.isArray(value)) {
            onChange(value);
        }
    }, [type, onChange]);
    return React.createElement(MenuOptionGroup, { type: type, onChange: valueChanged, ...props });
}
